import { gql } from '@apollo/client';
import { tenant,tenantType } from '../tenant';


const USER_NOTIFICATION=gql`
query GetUserNotification($id: bigint!) {
  clubmate_clubmatenotifications_clubmateusernotification(where: {user_id: {_eq: $id}, clubmatenotifications_clubmatenotification: {read: {_eq: false}}}, order_by: {clubmatenotifications_clubmatenotification: {data: desc}}) {
    clubmatenotifications_clubmatenotification {
      body
      data
      id
      read
      title
    }
  }
}
`

const DELETE_NOTIFICATION=gql`
mutation readNotification($id: bigint!, $read: Boolean) {
  update_clubmate_clubmatenotifications_clubmatenotification_by_pk(pk_columns: {id: $id}, _set: {read: $read}) {
    id
  }
}
`

export {USER_NOTIFICATION,DELETE_NOTIFICATION}